import React from "react";

import "./ManufacturerSliderItem.scss";

const ManufacturerSliderItem = (props) => {
    const { currentIndex, index, link, logo, headline, description, position } =
        props;

    return (
        <div
            className={
                index === currentIndex ? "slide active" : "slide " + position
            }
            key={index}
        >
            <a href={link} target="_blank" className="link" rel="noreferrer">
                <div className="logo">
                    <img src={logo} alt={headline} />
                </div>
                <div className="content">
                    <div className="title">
                        <h2>{headline}</h2>
                    </div>
                    <div className="description">
                        <p>{description}</p>
                    </div>
                </div>
            </a>
        </div>
    );
};

export default ManufacturerSliderItem;
